export const clients_sorting = [
  { label: "Website [SHORT]", value: "website:asc" },
  { label: "Website [SHORT]", value: "website:desc" },
  { label: "Tasks", value: "tasks:asc" },
  { label: "Tasks", value: "tasks:desc" },
  { label: "Status", value: "status:asc" },
  { label: "Status", value: "status:desc" },
  { label: "Subscription plan", value: "subscription:asc" },
  { label: "Subscription plan", value: "subscription:desc" },
];